import src from "IMAGE";
export default { src, width: 540, height: 540, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAP0lEQVR42q3KsQkAIAxE0Qi6gugicQTRJdK4/wxecaRIKX54zSUiP2swqMdjggWHNjevgMEk4+ZlUKik8eG9CwSAA/SCpiVMAAAAAElFTkSuQmCC"};
